import { render, staticRenderFns } from "./complaintHandling.vue?vue&type=template&id=06c2d4e5"
import script from "./complaintHandling.vue?vue&type=script&lang=js"
export * from "./complaintHandling.vue?vue&type=script&lang=js"
import style0 from "./complaintHandling.vue?vue&type=style&index=0&id=06c2d4e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports